import React, {useEffect, useRef, useState} from 'react'
import {SLowcodeList, STableActions, SActionBtn, SIDRender, SDropdown} from 'shj-components'
import config from './config.tsx'
import {useLocation, useNavigate} from 'react-router-dom'
import {apiData2Table} from '@/utils/data.ts'
import CheckThePhone from '@/components/CheckThePhone'
import {message, Tooltip, TreeSelect} from 'antd'
import {isNil, cloneDeep} from 'lodash-es'
import {allClueExport, clueExport, getAllCluePage} from "@/services/saleOpServices.ts";
import {dealSearch, filterSearchData2, isHeadquarters} from "@/utils/common.ts";
import {getEnums, httpOrgList} from "@/services/homeService.ts";
import {getChannelBrandAgent, getChannels, getChannelType} from "@/services/getUsers.ts";
import {getAllCompanyMrn, getRealEstateList} from "@/services/customerServices.ts";
import {getUser} from "@/common/utils.ts";
import KeepAlive from "react-activation";
import {departmentTree} from "@/services/content.ts";
import {getAnchorFn, getUserIdentityFn} from "@/pages/clueManage/utils.tsx";
import {getAuth} from "@/utils/auth.ts";
import {fileConfirm} from "@/utils/file.ts";
import {openInNewTab} from "@/utils/queryParse.ts";
import {InfoCircleOutlined} from "@ant-design/icons";

const treeRender = (list: any, key?: any, _title?: any) => {
  key = key || 'id'
  _title = _title || 'name'
  const newList = cloneDeep(list)
  return (newList || []).map((item: any, _index: any) => {
    item.title = item[_title]
    item.label = item[_title]
    item.value = item[key]
    item.key = item[key]
    if (item.children || item.childs) {
      item.children = treeRender(item.children || item.childs, key, _title)
    }
    return item
  })
}

const AllList = () => {
  const listRef = useRef<any>()
  const navigate = useNavigate()
  // const microAppData = window.microApp.getData()
  const userInfo = getUser()
  const dataLevel = userInfo?.dataLevel //权限等级  部门dataLevelDept 个人dataLevelPerson
  const companyId = userInfo?.companyId
  const dataDept = {
    // code: useInfo?.currentDepartmentPosition?.department['code'],
    // name: useInfo?.currentDepartmentPosition?.department['name'],
    code: '',
    name: '',
  } //部门
  const level = {
    dataLevelGroup: 1,
    dataLevelCompany: 2,
    dataLevelDept: 3,
    dataLevelPerson: 4,
  }[dataLevel]
  const [sourceChannel, setSourceChannel] = useState([])

  useEffect(() => {
    onCompanyChange(companyId)
  }, [companyId]);

  // 刷新
  const reloadFn = () => {
    const {
      current: {reload},
    } = listRef
    reload()
  }

  // 格式化参数
  const getSearchParams = (value: any) => {
    const {deptId, ucenterUserId} = value
    if (deptId || ucenterUserId) {
      value.relativesRequest = {
        deptId,
        ucenterUserId,
        dutyType: ucenterUserId && "subsidiary.salesman"
      }
    }

    let filter = dealSearch({...value, brands: value.brand ? [value.brand] : null})
    filter = filterSearchData2(filter, [
      ['createDate', 'createdTimeStartWith', 'createdTimeEndWith'],
      ['dispatchDate', 'dispatchTimeStart', 'dispatchTimeEnd'],
    ])
    delete filter.deptId
    delete filter.ucenterUserId
    return {...filter}
  }

  const fetchList = (values: any) => {
    return new Promise((resolve, reject) => {
      const {current, pageSize, query} = values
      const params = {
        allClueFlag: true,
        ...query,
      }
      getAllCluePage({params: {pageId: current, pageSize}, data: getSearchParams(params)})
          .then((resp: any) => {
            resolve(apiData2Table(resp))
          }).catch(reject)
    })
  }

  // 导出
  const onExport = async () => {
    const searchData_ = listRef.current.getSearch().getFieldsValue()
    message.loading({content: '导出中'})
    allClueExport(getSearchParams(searchData_))
        .then(() => {
          message.destroy()
          fileConfirm()
        })
        .catch(() => {
          message.destroy()
        })
  }
  // 导出 不含撞单
  const onCollisionExport = async () => {
    const searchData_ = listRef.current.getSearch().getFieldsValue()
    message.loading({content: '导出中'})
    allClueExport({...getSearchParams(searchData_), collisionFlag: false})
        .then(() => {
          message.destroy()
          fileConfirm()
        })
        .catch(() => {
          message.destroy()
        })
  }

  const onCompanyChange = async (value: any) => {
    if (value) {
      getRealEstateList({orgId: value}).then(res => {
        listRef?.current?.updateSearchData('buildingId', res)
      })
      getUserIdentityFn( ['ykf', 'ykfjl'], {companyId: value}).then(res =>{
        listRef?.current?.updateSearchData('ykf', res)
      })
      departmentTree(value, {
        "direction": "DOWN"
      }).then(res => {
        listRef?.current?.updateSearchData('saleDept', res)
      })
    } else {
      listRef?.current?.updateSearchData('buildingId', [])
      listRef?.current?.updateSearchData('ykf', [])
      listRef?.current?.updateSearchData('saleDept', [])
    }
  }
  const onMarketerDepChange = async (v: any) => {
    if (v) {
      getAllCompanyMrn({directlyUnder: {orgId: v, includeChild: true}}).then(res => {
        listRef?.current?.updateSearchData('salesman', res)
      })
    } else {
      listRef?.current?.updateSearchData('salesman', [])
    }
  }

  const getStatusOptions = () => {
    return Promise.all([
      httpOrgList(),
      getChannels(),
      getChannelBrandAgent(),
      getChannelType(),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.ClueStatusEnum'),
      getAnchorFn( 'ADVERT'),
      getUserIdentityFn(),
    ]).then(resp => {
      setSourceChannel(resp[1])
      return {
        companyList: resp[0],
        channels: resp[1],
        channelBrand: resp[2],
        channelType: resp[3],
        clueStatusEnum: resp[4],
        anchor: resp[5],
        seat: resp[6],
      }
    })
  }

  const onSearchReset = () => {
    listRef?.current?.updateSearchData('buildingId', [])
    listRef?.current?.updateSearchData('saleDept', [])
    listRef?.current?.updateSearchData('salesman', [])
  }

  const extension = {
    onSearchReset,
    request: {fetchList, getStatusOptions},
    events: {
      onCompanyChange,
      onMarketerDepChange,
      onExport,
      onCollisionExport,
    },
    auth: getAuth(),
    status: {
      btnDisabled: ({selectedRowKeys}: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      clueIdRender(text: any, record: any, index: any) {
        let label = text
        if (record?.sourceFlag == 'CONTENT_SHARING') {
          label += `-内`
        }
        return (
            <SIDRender
                id={label}
                onClick={() => {
                  openInNewTab(`/saleOp/businessManage/clueDispatch/clueDetail/${record.id}?authKey=clueList`)
                }}
            />
        )
      },
      checkPhone(text: any, record: any, index: any) {
        return (
            <CheckThePhone
                clueId={record.id}
                initValue={text}
                auth="clueDispatchViewPhone"
            />
        )
      },
      grossInfoRender(text: any, record: any, index: any) {
        if (isNil(text)) return '待定'
        if (text || text == 'true') return '是'
        if (!text || text == 'false') return '否'
      },
      publicCell(text: any, record: any, index: any) {
        let content = '线索列表'
        switch (record?.publicSea) {
          case 'public_seat':
            content = '呼叫公海池'
            break
          case 'public_sales':
            content = '营销公海池'
            break
          case 'public_fangao':
            content = '梵高CC回访池'
            break
          case 'public_temp':
            content = '待二次派单'
            break
        }
        switch (record?.collisionFlag) {
          case true:
            content = '撞单异常'
            break
        }
        if (!!record?.dispatchExceptionType && record?.dispatchExceptionType != 'NONE') {
          content = '派单异常'
        }
        return content
      },
      exportRender() {
        const items = [
          {
            label: '导出',
            key: 'warehousingClueExportBtn',
            auth: 'warehousingClueExportBtn',
            onClick: onExport,
            extra: <Tooltip title={'列表查询的线索（含撞单、派单异常、无效）'}>
              <InfoCircleOutlined />
            </Tooltip>
          },
          {
            label: '导出（不含撞单）',
            key: 'collisionClueExportBtn',
            auth: 'collisionClueExportBtn',
            onClick: onCollisionExport,
            extra: <Tooltip title={'列表查询的线索（含派单异常、无效，不含撞单）'}>
              <InfoCircleOutlined />
            </Tooltip>
          },
        ]
        return (
            <SDropdown menu={{items}} dropdownType="Button">
              导出
            </SDropdown>
        )
      },
    },
  }
  return (
      <div>
        <SLowcodeList config={{...config, [isHeadquarters() ? '' : 'searchInitialValues']: {orgId: companyId}}} ref={listRef} searchMode="group" {...extension} />
      </div>
  )
}
export default (props: any) => {
  const location = useLocation()
  return (
      <KeepAlive name={location.pathname}>
        <AllList {...props} />
      </KeepAlive>
  )
}
